import { render, staticRenderFns } from "./MyYwySecond.vue?vue&type=template&id=7889fc6f&"
import script from "./MyYwySecond.vue?vue&type=script&lang=js&"
export * from "./MyYwySecond.vue?vue&type=script&lang=js&"
import style0 from "./MyYwySecond.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports